import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, CardFooter, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Label, Row, Table, UncontrolledDropdown } from "reactstrap";
import { toast } from "react-toastify";

import { confirm } from "components/Confirmation";

import IconButton from "components/IconButton";
import CustomPagination from "components/CustomPagination";
import equipeService from "services/EquipeService";
import descarteService from "services/DescarteService";
import AppContext from "AppContext";
import { GFComboField } from "components/GeneralForm";
import { PapelEnum, ehPapelGestorContrato } from "services/PerfilService";
import comboService from "services/ComboService";
import { DestinacaoMaterialDescarteEnum } from "services/DescarteService";
import { MotivoDescarteEnumList } from "services/DescarteService";
import { DestinacaoMaterialDescarteEnumList } from "services/DescarteService";
import { StatusDescarteEnumList } from "services/DescarteService";
import { StatusDescarteEnum } from "services/DescarteService";
import ModalFinalizarDescarte from "./ModalFinalizarDescarte";


export default function Descartes() {
  const { state } = useContext(AppContext)
  const [pagina, setPagina] = useState(1)
  const [paginas, setPaginas] = useState(0)
  const [items, setItems] = useState([])
  const [empresas, setEmpresas] = useState([])
  const [idEmpresa, setIdEmpresa] = useState(null)
  const [motivoDescarte, setMotivoDescarte] = useState(null)
  const [destinacaoMaterial, setDestinacaoMaterial] = useState(null)
  const [status, setStatus] = useState(null)
  const [termo, setTermo] = useState('')
  const [dataInicio, setDataInicio] = useState("")
  const [dataFim, setDataFim] = useState("")
  const [configModalFinalizarDescarte, setConfigModalFinalizarDescarte] = useState()
  const navigate = useNavigate()

  const idTipoPerfil = state?.user?.perfil?.idTipo || 0
  const idContrato = state?.contrato?.id

  const podeGerenciar = (state?.user?.acoes || []).includes('descarte.gerenciar')

  const carregar = async () => {
    const res = await descarteService.get(
      idContrato,
      idEmpresa,
      motivoDescarte,
      destinacaoMaterial,
      status,
      termo,
      pagina,
      dataInicio || undefined,
      dataFim || undefined
    )
    if (res.success) {
      setItems(res.data.items)
      setPaginas(res.data.paginas)
    }
  }

  useEffect(() => {
    carregar()
  }, [pagina])

  useEffect(() => {
    if (ehPapelGestorContrato(idTipoPerfil)) {
      comboService.empresa(idContrato).then(res => {
        if (res.success) {
          setEmpresas(res.data)
        }
      })
    }
  }, [])

  const handleDelete = (item) => {
    confirm({
      header: "Exclusão",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          const res = await descarteService.delete(idContrato, item.id)
          if (res.success) {
            carregar()
            toast("Descarte excluído")
          } else {
            toast("Erro ao excluir o descarte")
          }
        } catch (ex) {
          if (!!ex.response?.data?.message)
            toast(ex.response.data.message)
          else
            toast("Erro ao excluir o descarte")
        }
      }
    })
  }

  const handleSubmit = e => {
    e.preventDefault()
    setPagina(1)
    carregar()
  }

  const handleDownloadDocumentoGerado = async (e, item) => {
    e.preventDefault()
    const signedUrl = await descarteService.getDocumentoGerado(idContrato, item.id)
    window.open(signedUrl, '_blank', 'noopener,noreferrer')
  }

  const handleDownloadDocumentoAssinado = async (e, item) => {
    e.preventDefault()
    const signedUrl = await descarteService.getDocumentoAssinado(idContrato, item.id)
    window.open(signedUrl, '_blank', 'noopener,noreferrer')
  }

  const handleDownloadCertificadoDescarte = async (e, item) => {
    e.preventDefault()
    const signedUrl = await descarteService.getCertificadoDescarte(idContrato, item.id)
    window.open(signedUrl, '_blank', 'noopener,noreferrer')
  }

  const handleOpenModalFinalizarDescarte = (item) => {
    setConfigModalFinalizarDescarte({
      idContrato,
      idDescarte: item.id,
      destinacaoMaterial: item.destinacaoMaterial,
      certificadoDescarte: item.certificadoDescarte,
      onChange: async () => {
        await carregar()
        setConfigModalFinalizarDescarte()
      }
    })
  }

  return (
    <>
      <Container fluid>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <h1 className="my-4">Descartes</h1>
          {podeGerenciar && (
            <Link className="btn btn-primary btn-icon" to="/admin/descartes/0">Incluir</Link>
          )}
        </div>

        <Card className="shadow mb-4">
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <FormGroup>
                    <Label>Componente, empresa destinatária ou setor</Label>
                    <Input type="text" placeholder="Componente, empresa destinatária ou setor" value={termo || ''} onChange={e => setTermo(e.target.value)} />
                  </FormGroup>
                </Col>
                <Col xs={2}>
                  <FormGroup>
                    <Label>Data Inicial</Label>
                    <Input
                      type="date"
                      value={dataInicio}
                      onChange={e => setDataInicio(e.target.value)}
                    />
                  </FormGroup>
                </Col>
                <Col xs={2}>
                  <FormGroup>
                    <Label>Data Final</Label>
                    <Input
                      type="date"
                      value={dataFim}
                      onChange={e => setDataFim(e.target.value)}
                    />
                  </FormGroup>
                </Col>
                <GFComboField
                  colspan={3}
                  label="Motivo do Descarte"
                  name="motivoDescarte"
                  data={{ motivoDescarte }}
                  onChange={(_, value) => setMotivoDescarte(value)}
                  options={MotivoDescarteEnumList}
                  optionValue="id"
                  optionLabel="nome"
                  showDefault
                />
              </Row>
              <Row>
                <GFComboField
                  colspan={3}
                  label="Destinação do Descarte"
                  name="destinacaoMaterial"
                  data={{ destinacaoMaterial }}
                  onChange={(_, value) => setDestinacaoMaterial(value)}
                  options={DestinacaoMaterialDescarteEnumList}
                  optionValue="id"
                  optionLabel="nome"
                  showDefault
                />
                <GFComboField
                  colspan={3}
                  label="Status do Descarte"
                  name="status"
                  data={{ status }}
                  onChange={(_, value) => setStatus(value)}
                  options={StatusDescarteEnumList}
                  optionValue="id"
                  optionLabel="nome"
                  showDefault
                />
                {(idTipoPerfil != PapelEnum.GESTOR_EMPRESA) && (
                  <GFComboField
                    colspan={4}
                    label="Empresa"
                    name="idEmpresa"
                    data={{ idEmpresa }}
                    onChange={(_, value) => setIdEmpresa(value)}
                    options={empresas}
                    optionValue="id"
                    optionLabel="razaoSocial"
                    showDefault
                  />
                )}
                <Col className="d-flex align-items-end justify-content-end">
                  <FormGroup>
                    <Button type="submit" color="primary">Buscar</Button>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card className="shadow">
          <Table className="align-items-center table-flush">
            <thead className="thead-light">
              <tr>
                <th scope="col">Data</th>
                <th scope="col">Empresa</th>
                <th scope="col">Motivo</th>
                <th scope="col">Destinação</th>
                <th scope="col">Status</th>
                <th scope="col">Qtd Componentes</th>
                <th scope="col" style={{ width: 120 }}></th>
              </tr>
            </thead>
            <tbody>
              {items.length == 0 && (
                <tr>
                  <td colSpan={7} className="text-center">Nenhum registro</td>
                </tr>
              )}
              {items.map(el => (
                <tr key={el.id}>
                  <td>{el.dataFmt}</td>
                  <td>{el.empresa}</td>
                  <td>{el.motivoDescarteFmt}</td>
                  <td>
                    {el.destinacaoMaterialFmt}
                    {el.destinacaoMaterial == DestinacaoMaterialDescarteEnum.DESCARTE_HOMOLOGADO && (
                      <>
                        <br />
                        {el.certificadoDescarte ? (
                          <small style={{ color: 'red' }}>Exige Certificado de Descarte</small>
                        ) : (
                          <small>Não exige Certificado de Descarte</small>
                        )}
                      </>
                    )}

                  </td>
                  <td>{el.statusFmt}</td>
                  <td>{el.qtdComponentes}</td>
                  <td className="text-right">
                    <UncontrolledDropdown>
                      <DropdownToggle data-toggle="dropdown" tag="span">
                        <IconButton alt="Ações" iconClass="bi-three-dots-vertical" />
                      </DropdownToggle>
                      <DropdownMenu right>
                        {podeGerenciar && (
                          <DropdownItem onClick={() => navigate(`/admin/descartes/${el.id}`)}>
                            Editar descarte
                          </DropdownItem>
                        )}
                        {(podeGerenciar && ![StatusDescarteEnum.FINALIZADO, StatusDescarteEnum.CANCELADO].includes(el.status)) && (
                          <DropdownItem onClick={() => handleDelete(el)}>
                            Excluir descarte
                          </DropdownItem>
                        )}
                        {(podeGerenciar && el.status == StatusDescarteEnum.AGUARDANDO_RETORNO_COMPROVANTE) && (
                          <DropdownItem onClick={() => handleOpenModalFinalizarDescarte(el)}>
                            Finalizar descarte
                          </DropdownItem>
                        )}
                        <DropdownItem onClick={(e) => handleDownloadDocumentoGerado(e, el)}>
                          Documento Gerado
                        </DropdownItem>
                        {el.status == StatusDescarteEnum.FINALIZADO && (
                          <>
                            <DropdownItem onClick={(e) => handleDownloadDocumentoAssinado(e, el)}>
                              Documento Assinado
                            </DropdownItem>
                            {(el.destinacaoMaterial == DestinacaoMaterialDescarteEnum.DESCARTE_HOMOLOGADO && el.certificadoDescarte) && (
                              <DropdownItem onClick={(e) => handleDownloadCertificadoDescarte(e, el)}>
                                Certificado de descarte
                              </DropdownItem>
                            )}
                          </>
                        )}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <CardFooter className="py-4">
            <CustomPagination pagina={pagina} paginas={paginas} onChange={setPagina} />
          </CardFooter>
        </Card>

        <ModalFinalizarDescarte
          config={configModalFinalizarDescarte}
          onClosed={() => setConfigModalFinalizarDescarte()}
        />
      </Container>
    </>
  )
}